import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import { useEffect, useState, useRef } from "react";
import { getAllEstimate, getAllParallelEstimate } from "../../actions/EstimateActions";
import Mobilemenu from "../../layouts/mobile-menu";
import Select from 'react-select';
import { styleSelect } from "../../constants/customStyles";
import { getInvestigationSchedule } from "../../actions/ReportActions";
import { getAllCustomer } from "../../actions/CustomerActions";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css"; // Core CSS
import "datatables.net-buttons";
import "datatables.net-buttons-dt/css/buttons.dataTables.css"; // Buttons CSS
import JSZip from "jszip";
import "datatables.net-buttons/js/buttons.html5.js"; // HTML5 export buttons
import "datatables.net-buttons/js/buttons.print"; // Print butt
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { investigationReportStyleSelect } from "../../constants/customStyles";
import * as ExcelJS from 'exceljs';


function InvestigationScheduleReport() {
    const tableRef = useRef();
    const [isHovered, setIsHovered] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const customers = useSelector(state => state?.customer?.customers?.data);
    const investigationScheduleData = useSelector(state => state?.reports?.investigationSchedule);

    const [filters, setFilters] = useState([]);
    const [filterOption, setFilterOption] = useState([]);
    const [searchPerformed, setSearchPerformed] = useState(false);

    const filterOptions = [
        { value: 'investigation_id', label: 'Investigation #' },
        { value: 'customer_id', label: 'Customer' },
        { value: 'plate_no', label: 'Plate #' },
        { value: 'chasis_no', label: 'Chasis #' },
    ];

    useEffect(() => {
        dispatch(getAllCustomer(null, 999999, null));
    }, [dispatch]);

    const handleFilter = (event) => {
        const { name, value } = event.target;
        setFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === name);
            if (index > -1) {
                updatedFilters[index].value = value;
            } else {
                updatedFilters.push({ key: name, value });
            }
            return updatedFilters;
        });
    };

    const handleFilterDropdown = (selectedOption) => {
        setFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const index = updatedFilters.findIndex(filter => filter.key === 'customer_id');
            if (index > -1) {
                updatedFilters[index] = { key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name };
            } else {
                updatedFilters.push({ key: 'customer_id', value: selectedOption.customer_id, label: selectedOption.name });
            }
            return updatedFilters;
        });
    };

    const handleClearFilter = () => {
        setFilters([]);
        setFilterOption([]);
        setSearchPerformed(false);
    };

    const exportToExcel = async () => {
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Investigation Schedule');

        // Get the table headers and data
        const table = tableRef.current;
        const headers = Array.from(table.querySelectorAll('thead tr:nth-child(3) th')).map(th => th.innerText);
        const secondHeaderRow = Array.from(table.querySelectorAll('thead tr:nth-child(2) th')).map(th => th.innerText);
        const rows = Array.from(table.querySelectorAll('tbody tr')).map(row => {
            return Array.from(row.querySelectorAll('td')).map(td => td.innerText);
        });

        // Add the second header row (styled)
        const secondHeader = worksheet.addRow(secondHeaderRow);

        // Apply styling to the second header row (A2:H2)
        secondHeader.eachCell((cell, colNumber) => {
            cell.font = { bold: true }; // Make text bold
            cell.alignment = { horizontal: 'center' }; // Center align text
            cell.fill = { // Set background color to light gray
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE0E0E0' },
            };
        });

        // Merge cells for the first header row (A1:H1)
        worksheet.mergeCells('A1:H1');

        // Add the regular header row (non-styled initially)
        const thirdHeader = worksheet.addRow(headers);

        // Apply bold styling to the third row
        thirdHeader.eachCell((cell, colNumber) => {
            cell.font = { bold: true }; // Make text bold
            cell.alignment = { horizontal: 'center' }; // Center align text
        });

        // Add rows to the worksheet
        rows.forEach(row => {
            worksheet.addRow(row);
        });

        // Apply borders to all cells in the worksheet
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Create a Blob and trigger download
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Investigation_Schedule.xlsx';
        link.click();
    };

    function createSvgIcon() {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute('width', '24');
        svg.setAttribute('height', '24');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        svg.classList.add('feather', 'feather-file-text', 'w-4', 'h-4', 'me-2');

        // Create SVG paths
        const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path1.setAttribute('d', 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z');
        svg.appendChild(path1);

        const polyline1 = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        polyline1.setAttribute('points', '14 2 14 8 20 8');
        svg.appendChild(polyline1);

        const line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line1.setAttribute('x1', '16');
        line1.setAttribute('y1', '13');
        line1.setAttribute('x2', '8');
        line1.setAttribute('y2', '13');
        svg.appendChild(line1);

        const line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line2.setAttribute('x1', '16');
        line2.setAttribute('y1', '17');
        line2.setAttribute('x2', '8');
        line2.setAttribute('y2', '17');
        svg.appendChild(line2);

        const polyline2 = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        polyline2.setAttribute('points', '10 9 9 9 8 9');
        svg.appendChild(polyline2);

        return svg;
    }

    const initializeTable = () => {

        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            return;
        }

        $(tableRef.current).DataTable({
            dom: "Bfrtip",
            paging: false,
            searching: false,
            ordering: false,
            info: false,
            dom: "Bfrtip",
            buttons: [
                {
                    extend: "print",
                    text: "Print Report",
                    title: "",
                    customize: function (win) {
                        const $win = $(win.document.body);

                        $win.find("table").css({
                            // border: "1px solid black",
                            "width": "95%"
                        });

                        $win.find("table td, table th").css({
                            "word-wrap": "break-word",
                        });

                        const img = $("<img>")
                            .attr("src", "/images/invoice-head.jpg")
                            .attr("width", "100%")
                            .attr("height", "60")
                            .attr("alt", "Invoice Header")
                            ;

                        const imgTwo = $("<img>")
                            .attr("src", "/images/invoice-foot.jpg")
                            .attr("width", "100%")
                            .attr("height", "40")
                            .attr("alt", "Invoice Footer")
                            ;

                        $win.find("table thead tr").eq(0).find("th").html(img);

                        $win.find("table thead tr").eq(1).find("th").css({
                            "text-align": "center",
                            "text-decoration": "underline",
                            "font-size": "20px",
                            background: "#E0E0E0",
                            "font-weight": "bold",
                            padding: "3px",
                        });

                        $win.find("table thead tr").eq(3).find("th").css({
                            "font-size": "11px",
                            "padding": "3px"
                        });

                        $win.find("table tbody tr").find("td").css({
                            "font-size": "10px",
                            "padding": "3px"
                        });

                        $win.find("table tfoot tr").eq(0).find("th").html(imgTwo);

                        // Add margin-bottom to each page
                        $win.css({
                            "margin-bottom": "50px"
                        });
                    },
                },
            ],
        }, [])
        // Wait for dt-buttons to be available, then append the Export Excel button
        setTimeout(() => {
            const dtButtonsContainer = document.querySelector('.dt-buttons');
            dtButtonsContainer.classList.add('d-flex', 'justify-content-end');
            if (dtButtonsContainer) {
                // Create the Export Excel button
                const excelButton = document.createElement('button');
                excelButton.className = 'btn btn-elevated-primary w-24 mt-2 mb-2';
                excelButton.style.marginLeft = '10px';
                excelButton.onmouseenter = () => setIsHovered(true);
                excelButton.onmouseleave = () => setIsHovered(false);
                excelButton.onclick = exportToExcel;

                // Use the helper function to create the SVG
                const excelSvg = createSvgIcon();

                // Create text node for the button label
                const buttonText = document.createTextNode('Export');

                // Append the SVG and text to the button
                excelButton.appendChild(excelSvg);
                excelButton.appendChild(buttonText);

                // Append the button to dt-buttons
                dtButtonsContainer.appendChild(excelButton);

                // Check and modify the print button if it exists
                const printButton = document.querySelector('.dt-button.buttons-print');
                if (printButton) {
                    // Clear the existing content of the Print button
                    printButton.innerHTML = '';

                    // Use the same SVG for the Print button
                    const printSvg = createSvgIcon();
                    printButton.appendChild(printSvg);
                    printButton.appendChild(document.createTextNode('Print'));

                    // Apply same styling as the Export button
                    printButton.classList.add('btn', 'btn-elevated-primary', 'w-24', 'mt-2', 'mb-2');
                    printButton.classList.remove('dt-button', 'buttons-print');
                }
            }
        }, 50);
    };
    const filterSearch = () => {
        const filterParams = filters.reduce((acc, filter) => {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        dispatch(getInvestigationSchedule(filterParams));
        // initializeTable();
        // setSearchPerformed(true);
    };

    useEffect(() => {
        if (investigationScheduleData && Array.isArray(investigationScheduleData)) {
            setSearchPerformed(true);
        }
    }, [investigationScheduleData])

    useEffect(() => {
        const updatedFilters = filterOption.map(option => {
            const existingFilter = filters.find(filter => filter.key === option.value);
            return existingFilter || { key: option.value, value: '', label: option.label };
        });

        const preservedDateFilters = filters.filter(filter =>
            ['date_from', 'date_to'].includes(filter.key) &&
            !filterOption.some(option => option.value === filter.key)
        );

        setFilters([...updatedFilters, ...preservedDateFilters]);
    }, [filterOption]);

    useEffect(() => {
        if (searchPerformed) {
            initializeTable();
        }
    }, [searchPerformed]);

    return (
        <span>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />

                    <span>
                        {/* <!-- BEGIN: Data List --> */}
                        <div className="intro-y g-col-12 px-3 mt-5 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">

                            <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                aria-controls="faq-accordion-collapse-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                Filters </button>
                        </div>
                        <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show show mt-5" aria-labelledby="faq-accordion-content-1"
                            data-bs-parent="#faq-accordion-1">
                            <div class="grid columns-12 gap-6 mt-5">
                                <div class="intro-y g-col-12 g-col-lg-12">
                                    <div class="intro-y box p-5">
                                        <div class="row">
                                            <div className="col-lg-3 col-md-6 mt-2">
                                                <label className="form-label font-weight-bold">Date From</label>
                                                <input
                                                    type="date"
                                                    name="date_from"
                                                    value={filters.find(filter => filter.key === 'date_from')?.value || ''}
                                                    onChange={handleFilter}
                                                    className="form-control w-full"
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-6 mt-2">
                                                <label className="form-label font-weight-bold">Date To</label>
                                                <input
                                                    type="date"
                                                    name="date_to"
                                                    value={filters.find(filter => filter.key === 'date_to')?.value || ''}
                                                    onChange={handleFilter}
                                                    className="form-control w-full"
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-4 mt-2">
                                                <label className="form-label">Filter</label>
                                                <Select
                                                    isMulti
                                                    styles={styleSelect}
                                                    value={filterOption || []}
                                                    onChange={setFilterOption}
                                                    options={filterOptions}
                                                />
                                            </div>
                                            {filters
                                                .filter(filter => !['date_from', 'date_to'].includes(filter.key))
                                                .map((filter, index) => (
                                                    filter.key === 'customer_id' ? (
                                                        <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                            <label className="form-label font-weight-bold">Customer Name</label>
                                                            <Select
                                                                onChange={handleFilterDropdown}
                                                                value={customers && customers.find(cust => cust.customer_id === filter.value) || null}
                                                                getOptionLabel={option => `${option.name} - ${option.mobile || 'N/A'}`}

                                                                getOptionValue={option => option.customer_id}
                                                                options={customers || []}
                                                                styles={styleSelect}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div key={index} className="col-lg-3 col-md-4 mt-2">
                                                            <label className="form-label font-weight-bold">{filterOptions.find(opt => opt.value === filter.key)?.label}</label>
                                                            <input
                                                                type="text"
                                                                value={filter.value}
                                                                onChange={(event) => handleFilter({ target: { name: filter.key, value: event.target.value } })}
                                                                className="form-control w-full"
                                                            />
                                                        </div>
                                                    )
                                                ))}
                                        </div>
                                        <div class="text-end mt-5">
                                            <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                Search</button>
                                            <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </span>
                    {/* } */}
                    {searchPerformed && (
                        <>
                            <div className="mt-5">
                                {/* <button
                                style={{
                                    ...investigationReportStyleSelect.button,
                                    ...(isHovered ? investigationReportStyleSelect.buttonHover : {}),
                                }}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={exportToExcel}>Export Excel</button> */}
                                <table
                                    ref={tableRef}
                                    className="table table-bordered"
                                    style={{
                                        width: '100%',
                                        background: 'white',
                                        borderCollapse: 'collapse',
                                        marginBottom: '20px',
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th colSpan={8} style={{ background: 'white' }}>
                                                <img
                                                    src="/images/invoice-head.jpg"
                                                    width="100%"
                                                    height="60"
                                                    alt="Invoice Header"
                                                />
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                className="custom-heading"
                                                colSpan={8}
                                                style={{
                                                    textAlign: 'center',
                                                    textDecoration: 'underline',
                                                    fontSize: '20px',
                                                    background: '#E0E0E0',
                                                    fontWeight: 'bold',
                                                    padding: '5px',
                                                }}
                                            >
                                                INVESTIGATION SCHEDULE
                                            </th>
                                        </tr>
                                        <tr style={{ background: 'white' }}>
                                            <th>JOB ID</th>
                                            <th>REF</th>
                                            <th>INVESTIGATION IN DATE</th>
                                            <th>CUSTOMER</th>
                                            <th>MAKE</th>
                                            <th>REG NO</th>
                                            <th>COMPANY</th>
                                            <th>REMARKS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(investigationScheduleData) && investigationScheduleData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item?.estimate?.job_card?.job_card_id}</td>
                                                <td>{item?.estimate?.insurance_company?.name}</td>
                                                <td>{new Date(item?.created_at).toLocaleDateString('en-GB')}</td>
                                                <td>{item?.customer?.name}</td>
                                                <td>{item?.vehicle?.vehicle_make?.name}</td>
                                                <td>{item?.vehicle?.plate_number}</td>
                                                <td>{item?.estimate?.insurance_company?.name}</td>
                                                <td>{item?.remarks}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    {/* <tfoot>
                                        <tr style={{ background: 'white' }}>
                                            <th colSpan={8}>
                                                <img
                                                    src="/images/invoice-foot.jpg"
                                                    width="100%"
                                                    height="60"
                                                    alt="Invoice Footer"
                                                />
                                            </th>
                                        </tr>
                                    </tfoot> */}
                                </table>
                            </div>
                            <div className="footer-image">
                                <hr />
                                <img
                                    src="/images/invoice-foot.jpg"
                                    width="100%"
                                    height="60"
                                    alt="Invoice Footer"
                                />
                            </div>
                        </>
                    )}
                </div >
            </div >
        </span >
    )
}
export default InvestigationScheduleReport;